<template>
  <div class="appointment-progress">
    <div
      :class="{ 'progress__item--active': current_step === 1 }"
      class="progress__item"
    >
      <span class="progress__number">1</span>
      <span class="progress__title">Selecciona tu servicio</span>
    </div>
    <div
      :class="{ 'progress__item--active': current_step === 2 }"
      class="progress__item"
    >
      <span class="progress__number">2</span>
      <span class="progress__title">Seleccionar servicio técnico</span>
    </div>
    <div
      :class="{ 'progress__item--active': current_step === 3 }"
      class="progress__item"
    >
      <span class="progress__number">3</span>
      <span class="progress__title">Seleccionar fecha y horario</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Progress',
  computed: {
    ...mapState(['current_step']),
  },
};
</script>

<style></style>
